/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/18
 * @updateTime 2021/8/18
 * @decription 公共业务组件-文件上传组件
 */
// 文件限制
import { FILE_LIMIT } from "@/utils/consts";
// 获取id的接口
import {getId} from "@/api/common";
import {getJcbqScclList} from "@/api/guarantee";

export default {
    name: 'acUploadFile',
    // 混入
    mixins: [],
    // 依赖组件
    components: {},
    // 双向绑定
    model: {
        prop: 'data',
        event: 'change'
    },
    // 参数
    props: {
        // 数据列表
        data: Array,
        // 名称
        name: String,
        // 是否禁用
        disabled: Boolean,
        // 是否只读
        readonly: Boolean,
        // 是否可删除，默认可以删除
        deletable: {
            type: Boolean,
            default: true
        },
        // 上传请求参数
        uploadParam: Object|Function,
        // 上传地址
        uploadUrl: {
            type: String,
            require: true
        },
        // 删除参数
        deleteParam: Object|Function,
        // 删除接口url
        deleteUrl: String,
        // 获取上传文件数据
        getUploadFileData: Function,
        // 文件上传数量限制
        maxCount: Number|String,
        // id属性
        idProp: {
            type: String,
            default: 'cId'
        },
        uploadText: String
    },
    // 数据
    data() {
        return {
            // 当前作用域变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-ac-upload-file'
            },
            // 已上传的文件列表
            fileList: [],
            // 是否正在上传
            isUploading: false
        };
    },
    // 计算属性
    computed: {
        /**
         * 容器类名
         * @returns {Array<String>} 类名数组
         * */
        wrapClasses() {
            return [
                this.scope.prefixCls,
                // 是否只读
                this.readonly ? 'readonly': ''
            ];
        }
    },
    // 监听
    watch: {
        /**
         * 监听数据变化
         * */
        data: {
            // 立即执行
            immediate: true,
            getcild: '',
            fileDate: null,
            // 发生变化，更新按钮数据
            handler (newValue) {
                // 如果数据不等于当前列表，则进行文件列表的赋值
                if (newValue !== this.fileList) {
                    this.fileList = newValue;
                }
            }
        }
    },
    // 创建完成
    created() {
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {

        /**
         * 验证文件
         * @param {File} file 文件对象
         * @returns {Boolean} 是否可以上传文件
         * */
        validateFile(file) {
            // 校验文件是否为空
            if (file.size === 0) {
                this.$notify('上传文件必须大于0kb!');
                return false;
            }
            // 校验类型
            if (FILE_LIMIT.type.indexOf(file.type) === -1) {
                this.$notify({
                    message: `仅支持格式为${FILE_LIMIT.format}的图片!`,
                    duration: 5 * 1000
                })
                return false;
            }
            // 校验最大大小
            if (file.size > FILE_LIMIT.size) {
                this.$notify('上传文件大小不能超过20MB!');
                return false;
            }
            return true;
        },

        /**
         * 更新双向绑定数据
         * @returns {void}
         * */
        updateModelData() {
            // 触发change事件进行数据的修改
            this.$emit('change', this.fileList);
        },

        /**
         * 新增文件数据
         * @param {Object} data 请求返回数据
         * @returns {void}
         * */
        addFileData(data) {
            // 文件数据
            const _fileData = this.getUploadFileData ? this.getUploadFileData(data, this.fileList[this.fileList.length - 1]) : data.sqfj;
            // 如果数据存在，则进行替换
            if (_fileData) {
                // 将最后一个数据换成对应的数据
                this.fileList.splice(this.fileList.length - 1, 1, _fileData);
            }
            // 更新双向绑定数据
            this.updateModelData();
        },

        /**
         * 根据id删除文件数据
         * @param {String} id
         * @returns {void}
         * */
        deleteFileData(id) {
            // debugger
            this.fileList.some((item, index) => {
                if (item[this.idProp] === id) {
                    this.fileList.splice(index, 1);
                    return true;
                }
                return false;
            });
            // 更新双向绑定数据
            this.updateModelData();
        },

        /**
         * 获取id
         * */
        myId(i) {
            return new Promise((resolve, reject) => {
                i++
                if (i > 3) {
                    this.$notify('系统错误，请重试!');
                    reject();
                } else {
                    getId().then((res) => {
                        resolve(res.data)
                    }).catch(() => {
                        return this.myId(i);
                    })
                }
            })
        },

        /**
         * 停止上传
         * @returns {void}
         * */
        stopUpload() {
            // 删除最后一个
            this.fileList.splice(this.fileList.length - 1, 1);
        },

        /**
         * 上传文件
         * @param {File} file 文件对象
         * @returns {void}
         * */
        async uploadFile(file) {
            // 当前正在上传
            this.isUploading = true;
            // 开始上传
            this.$emit('upload-start');
            // 表单对象
            const _formData = new FormData();
            // 上传文件
            const _file = file.file;
            // 材料id
            let clid = await this.myId(0);
            _formData.append("file", _file);
            // 上传参数
            let _uploadParam = null;
            // 如果上传参数是方法
            if (typeof this.uploadParam === 'function') {
                _uploadParam = this.uploadParam(_file, clid, _formData);
            } else if (this.uploadParam) {
                _uploadParam = this.uploadParam;
            }
            // 新增其他的参数
            if (_uploadParam) {
                Object.keys(_uploadParam).forEach((key) => {
                    _formData.append(key, _uploadParam[key]);
                })
            }
            // 请求上传接口
            this.$axios.post(this.uploadUrl, _formData)
                .then(res => {
                    // 当前正在上传
                    this.isUploading = false;
                    if (res.code === 200) {
                        // 新增数据
                        this.addFileData(res.data);
                        this.$notify({'type': 'success', 'message': '材料上传成功'});
                        // 分发上传成功
                        this.$emit('upload-success');
                    } else {
                        this.$notify(res.message);
                        // 停止上传
                        this.stopUpload();
                    }
                    // 上传结束
                    this.$emit('upload-end');
                })
                .catch((error) => {
                    // 当前正在上传
                    this.isUploading = false;
                    // 请求数据
                    const _resData = error.response.data;
                    this.$notify(_resData.message ? _resData.message : '系统异常');
                    // 停止上传
                    this.stopUpload();
                    // 上传结束
                    this.$emit('upload-end');
                });
        },

        /**
         * 删除文件
         * */
        deleteFile(fileData) {
            this.$axios.delete(this.deleteUrl, {
                clid: fileData[this.idProp],
                ...(typeof this.deleteParam === 'function' ? this.deleteParam(fileData) : this.deleteParam)
            })
                .then(res => {
                    if (res.code == 200) {
                        // 删除对应的数据
                        this.deleteFileData(fileData[this.idProp]);
                        this.$notify({'type': 'success', 'message': '材料删除成功'});
                    } else {
                        this.$notify(res.message);
                    }
                })
                .catch(() => {
                    this.$notify("系统异常");
                });
        }
    }
};
